import axios from 'axios';

// const backend_endpoint = process.env.REACT_APP_BACK_END_ENDPOINT !== undefined ? process.env.REACT_APP_BACK_END_ENDPOINT : 'https://wapi-#{CLIENTNAME}##{INSTANCE}#-sdinsight.azurewebsites.net';
const backend_endpoint = process.env.REACT_APP_BACK_END_ENDPOINT ?? '';

export async function createIncident(incidentText, accessToken) {
    const data = { summary : incidentText };
    const headers = { 'Authorization': `Bearer ${accessToken}`,'Content-Type': 'application/json' };
    
    const endpoint = backend_endpoint 
            ? `${backend_endpoint}/api/aiops/createincident` 
            : '/api/aiops/createincident';

    // const res = await axios.post(endpoint + '/aiops/createincident', data, {headers}); 
    const res = await axios.post(endpoint, data, { headers });
    return res.data;
}